var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Account Deletion Survey" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _vm.isEdit
                  ? _c("Button", {
                      attrs: { variant: "default", label: "Cancel" },
                      on: { clicked: _vm.cancelEdit }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("Button", {
                  attrs: { variant: "primary", label: _vm.textButtonEdit },
                  on: { clicked: _vm.actionEdit }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col" },
                  [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "text-gray-700 text-sm mt-3 mb-6 font-bold uppercase text-left"
                      },
                      [
                        _vm._v(
                          "\n          Account Deletion Survey Form\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Title" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "relative" },
                                [
                                  _c("Input", {
                                    attrs: {
                                      disabled: !_vm.isEdit,
                                      placeholder: "Input Title",
                                      error:
                                        _vm.$v.title.$dirty &&
                                        !_vm.$v.title.required,
                                      maxlength: "25"
                                    },
                                    model: {
                                      value: _vm.title,
                                      callback: function($$v) {
                                        _vm.title = $$v
                                      },
                                      expression: "title"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "absolute right-0 text-xs",
                                      staticStyle: {
                                        top: "15px",
                                        right: "15px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.title.length) + "/25")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.title.$dirty && !_vm.$v.title.required
                                    ? _c("text-error", {
                                        attrs: { text: "Please fill Title." }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("form-item", {
                      attrs: { label: "Description" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "relative" },
                                [
                                  _c("TextArea", {
                                    attrs: {
                                      disabled: !_vm.isEdit,
                                      placeholder: "Input Description",
                                      error:
                                        _vm.$v.description.$dirty &&
                                        !_vm.$v.description.required,
                                      maxlength: "128",
                                      rows: "2"
                                    },
                                    model: {
                                      value: _vm.description,
                                      callback: function($$v) {
                                        _vm.description = $$v
                                      },
                                      expression: "description"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "absolute right-0 text-xs",
                                      staticStyle: {
                                        bottom: "15px",
                                        right: "15px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.description.length) + "/128"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex flex-col pt-2" },
                                [
                                  _vm.$v.description.$dirty &&
                                  !_vm.$v.description.required
                                    ? _c("text-error", {
                                        attrs: {
                                          text: "Please fill Description."
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex border-b border-gray-200 py-3 justify-between"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex flex-col" },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "text-gray-700 text-sm py-2 font-bold uppercase"
                          },
                          [_vm._v("\n            Options\n          ")]
                        ),
                        _vm._v(" "),
                        _vm.$v.listOptions.$dirty &&
                        !_vm.$v.listOptions.minLength
                          ? _c("text-error", {
                              attrs: { text: "Options at least have 2 item" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.listOptions.length > 0
                  ? _c(
                      "el-table-draggable",
                      {
                        attrs: { handle: ".handle-move", disabled: !_vm.isEdit }
                      },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.listOptions,
                              "row-key": "id",
                              "show-header": false
                            }
                          },
                          [
                            _c(
                              "el-table-column",
                              {
                                key: "handle",
                                attrs: {
                                  label: "Handle",
                                  align: "center",
                                  width: "100px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "static inline-block text-center container-action handle-move",
                                    staticStyle: { cursor: "move" }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { size: "2x", icon: ["fa", "th"] }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "Actions",
                                align: "left",
                                width: "450px"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "static inline-block text-left container-action w-full"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "relative" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.$v.listOptions
                                                          .$each[scope.$index]
                                                          .name.$model,
                                                      expression:
                                                        "$v.listOptions.$each[scope.$index].name.$model",
                                                      modifiers: { trim: true }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "block border border-grey-light w-full p-3 rounded",
                                                  class:
                                                    _vm.$v.listOptions.$each[
                                                      scope.$index
                                                    ].name.$dirty &&
                                                    !_vm.$v.listOptions.$each[
                                                      scope.$index
                                                    ].name.required
                                                      ? "border-red-500"
                                                      : "",
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "36",
                                                    disabled: !_vm.isEdit
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.$v.listOptions.$each[
                                                        scope.$index
                                                      ].name.$model
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.$set(
                                                        _vm.$v.listOptions
                                                          .$each[scope.$index]
                                                          .name,
                                                        "$model",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.isEdit
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "absolute right-0 text-xs",
                                                        staticStyle: {
                                                          top: "15px",
                                                          right: "15px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.listOptions[
                                                              scope.$index
                                                            ].name.length
                                                          ) + "/36"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.$v.listOptions.$each[
                                              scope.$index
                                            ].name.$dirty &&
                                            !_vm.$v.listOptions.$each[
                                              scope.$index
                                            ].name.required
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-red-500 text-xs italic text-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Please fill the Option."
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1550956093
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "Actions",
                                align: "left",
                                width: "350px"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "static inline-block text-left container-action w-full"
                                          },
                                          [
                                            _vm.isEdit
                                              ? _c("div", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.listOptions[
                                                            scope.$index
                                                          ].show_text_field,
                                                        expression:
                                                          "listOptions[scope.$index].show_text_field"
                                                      }
                                                    ],
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        _vm.listOptions[
                                                          scope.$index
                                                        ].show_text_field
                                                      )
                                                        ? _vm._i(
                                                            _vm.listOptions[
                                                              scope.$index
                                                            ].show_text_field,
                                                            null
                                                          ) > -1
                                                        : _vm.listOptions[
                                                            scope.$index
                                                          ].show_text_field
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.listOptions[
                                                              scope.$index
                                                            ].show_text_field,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                _vm.listOptions[
                                                                  scope.$index
                                                                ],
                                                                "show_text_field",
                                                                $$a.concat([
                                                                  $$v
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                _vm.listOptions[
                                                                  scope.$index
                                                                ],
                                                                "show_text_field",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            _vm.listOptions[
                                                              scope.$index
                                                            ],
                                                            "show_text_field",
                                                            $$c
                                                          )
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "Show text field when user pick this option"
                                                    )
                                                  ])
                                                ])
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3072876709
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "Actions", align: "right" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "static inline-block text-left container-action"
                                          },
                                          [
                                            _vm.isEdit
                                              ? _c(
                                                  "VueCustomTooltip",
                                                  {
                                                    attrs: {
                                                      label: "Delete",
                                                      position: "is-left"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.del(
                                                              scope
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass:
                                                              "text-white",
                                                            attrs: {
                                                              icon: [
                                                                "fa",
                                                                "trash-alt"
                                                              ]
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3126905744
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEdit
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer w-full\n                            border duration-200 ease-in-out transition",
                        class: _vm.maxOptions
                          ? "border-gray-600 bg-gray-700 text-gray-100 hover:bg-gray-100 hover:text-gray-700"
                          : "border-blue-600 bg-blue-700 text-blue-100 hover:bg-blue-100 hover:text-blue-700",
                        attrs: { disabled: _vm.maxOptions },
                        on: { click: _vm.addOption }
                      },
                      [_vm._v("Add Option")]
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-94630662", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94630662","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AppSetting/AccountDeletionSurvey.vue
// module id = null
// module chunks = 